import { TEAMS_CALLS_HELP_ARTICLE_URL } from '../../../../../common/integrations'

export const TeamsCallsHowItWorks = () => {
  return (
    <div>
      <div>
        <h5>1. Connect your Microsoft account</h5>
        <div className='mt-2'>
          Zocks redirects you to Microsoft, where you can sign in and authorize access to your call recordings. If your firm manages your Microsoft account,
          your IT team may need to approve access first.
        </div>
        <div className='mt-2'>Call capture starts when you connect. To stop call capture, disconnect the integration.</div>
      </div>
      <div className='mt-3'>
        <h5>2. Record calls in Microsoft Teams</h5>
        <div className='mt-2'>Calls must be recorded in Microsoft Teams before Zocks can process them.</div>
        <div className='mt-2'>
          During the call, select <span className='fw-bold'>More &gt; Record and transcribe &gt; Start recording</span>. Recording behavior is managed in
          Microsoft Teams, not in Zocks.
        </div>
        <div className='mt-2'>Zocks receives the recording when you start the recording in these calls:</div>
        <ul className='mt-2'>
          <li>Phone calls that you make or receive in Teams</li>
          <li>1:1 Teams calls</li>
          <li>Group Teams calls that you start</li>
        </ul>
        <div className='mt-2'>Zocks does not receive the recording in these cases:</div>
        <ul className='mt-2'>
          <li>The other person starts the recording in a 1:1 Teams call</li>
          <li>Another person starts the group call, also when you record it</li>
          <li>
            Scheduled Teams meetings and Meet now meetings. For meetings, the Zocks AI Notetaker joins when you sync your calendar or invite it to the meeting
          </li>
        </ul>
      </div>
      <div className='mt-3'>
        <h5>3. Zocks processes the recording</h5>
        <div className='mt-2'>
          Zocks does not show the call as live. After the call ends, Zocks receives the recording, usually within a few minutes, and creates a meeting record
          from it.
        </div>
        <div className='mt-2'>
          Zocks creates one meeting record for each recording. If you stop and start the recording again in the same call, you get more than one meeting record.
        </div>
        <div className='mt-2'>
          If no Teams recording exists for the call, Zocks will not generate notes, summaries, transcripts, or CRM updates from that call.
        </div>
      </div>
      <div className='mt-4'>
        <h5>Recommended Microsoft Teams setup</h5>
        <div className='mt-2'>
          Your Microsoft 365 administrator must allow cloud recording for calls in the Teams admin center, and approve Zocks access to call recordings.
        </div>
        <div className='mt-2'>
          Your organization is responsible for configuring Teams recording settings, recording consent, storage, and retention according to your internal
          policies and applicable regulations.
        </div>
        <div className='mt-2'>
          Need help? See the{' '}
          <a href={TEAMS_CALLS_HELP_ARTICLE_URL} target='_blank' rel='noreferrer'>
            Microsoft Teams Calls setup guide
          </a>
          .
        </div>
      </div>
    </div>
  )
}
